import {
  IUserBusinessDto,
  ICreateBusinessDto,
  IUserDto,
  IUserListDto,
  IUserFiltersDto,
} from "../../interfaces/dto/user.dto";

export enum UserActions {
  USER_BUSINESS = "USER_BUSINESS",
  USER_BUSINESS_SUCCESS = "USER_BUSINESS_SUCCESS",
  USER_BUSINESS_FAILURE = "USER_BUSINESS_FAILURE",
  USER_GET_INFO = "USER_GET_INFO",
  USER_GET_INFO_SUCCESS = "USER_GET_INFO_SUCCESS",
  USER_GET_INFO_FAILURE = "USER_GET_INFO_FAILURE",
  USER_CREATE_BUSINESS = "USER_CREATE_BUSINESS",
  USER_CREATE_BUSINESS_SUCCESS = "USER_CREATE_BUSINESS_SUCCESS",
  USER_CREATE_BUSINESS_FAILURE = "USER_CREATE_BUSINESS_FAILURE",
  USER_UPDATE_BUSINESS = "USER_UPDATE_BUSINESS",
  USER_UPDATE_BUSINESS_SUCCESS = "USER_UPDATE_BUSINESS_SUCCESS",
  USER_UPDATE_INFO = "USER_UPDATE_INFO",
  USER_UPDATE_INFO_SUCCESS = "USER_UPDATE_INFO_SUCCESS",
  USER_GET_LIST = "USER_GET_LIST",
  USER_GET_LIST_SUCCESS = "USER_GET_LIST_SUCCESS",
  USER_GET_LIST_FAILURE = "USER_GET_LIST_FAILURE",
  USER_SET_LIST_FILTERS = "USER_SET_LIST_FILTERS",
}

interface ISetListFiltersAction {
  type: UserActions.USER_SET_LIST_FILTERS;
  payload: IUserFiltersDto;
}

export const setListFiltersAction = (
  payload: IUserFiltersDto,
): ISetListFiltersAction => ({
  type: UserActions.USER_SET_LIST_FILTERS,
  payload,
});

interface IGetUserListAction {
  type: UserActions.USER_GET_LIST;
}

export const getUserListAction = (): IGetUserListAction => ({
  type: UserActions.USER_GET_LIST,
});

export interface IGetUserListSuccessAction {
  type: UserActions.USER_GET_LIST_SUCCESS;
  payload: IUserListDto;
}

export const getUserListSuccessAction = (
  payload: IUserListDto,
): IGetUserListSuccessAction => ({
  type: UserActions.USER_GET_LIST_SUCCESS,
  payload,
});

export interface IGetUserListFailureAction {
  type: UserActions.USER_GET_LIST_FAILURE;
  payload: { error: string };
}

export const getUserListFailureAction = (
  error: string,
): IGetUserListFailureAction => ({
  type: UserActions.USER_GET_LIST_FAILURE,
  payload: { error },
});

interface IUpdateUserInfoAction {
  type: UserActions.USER_UPDATE_INFO;
}

export const updateUserInfoAction = (): IUpdateUserInfoAction => ({
  type: UserActions.USER_UPDATE_INFO,
});

export interface IUpdateUserInfoSuccessAction {
  type: UserActions.USER_UPDATE_INFO_SUCCESS;
  payload: IUserDto;
}

export const updateUserInfoSuccessAction = (
  payload: IUserDto,
): IUpdateUserInfoSuccessAction => ({
  type: UserActions.USER_UPDATE_INFO_SUCCESS,
  payload,
});

interface IUpdateBusinessAction {
  type: UserActions.USER_UPDATE_BUSINESS;
}

export const updateBusinessAction = (): IUpdateBusinessAction => ({
  type: UserActions.USER_UPDATE_BUSINESS,
});

interface IGetUserInfoAction {
  type: UserActions.USER_GET_INFO;
}

export const getUserInfoAction = (): IGetUserInfoAction => ({
  type: UserActions.USER_GET_INFO,
});

export interface IGetUserInfoSuccessAction {
  type: UserActions.USER_GET_INFO_SUCCESS;
  payload: IUserDto;
}

export const getUserInfoSuccessAction = (
  payload: IUserDto,
): IGetUserInfoSuccessAction => ({
  type: UserActions.USER_GET_INFO_SUCCESS,
  payload,
});

interface IGetUserInfoFailureAction {
  type: UserActions.USER_GET_INFO_FAILURE;
  payload: {
    error: string;
  };
}

export const getUserInfoFailureAction = (
  error: string,
): IGetUserInfoFailureAction => ({
  type: UserActions.USER_GET_INFO_FAILURE,
  payload: {
    error,
  },
});

interface ICreateBusinessAction {
  type: UserActions.USER_CREATE_BUSINESS;
}

export const createBusinessAction = (): ICreateBusinessAction => ({
  type: UserActions.USER_CREATE_BUSINESS,
});

export interface ICreateBusinessSuccessAction {
  type: UserActions.USER_CREATE_BUSINESS_SUCCESS;
  payload: ICreateBusinessDto;
}

export const createBusinessSuccessAction = (
  payload: ICreateBusinessDto,
): ICreateBusinessSuccessAction => ({
  type: UserActions.USER_CREATE_BUSINESS_SUCCESS,
  payload,
});

interface ICreateBusinessFailureAction {
  type: UserActions.USER_CREATE_BUSINESS_FAILURE;
  payload: {
    error: string;
  };
}

export const createBusinessFailureAction = (
  error: string,
): ICreateBusinessFailureAction => ({
  type: UserActions.USER_CREATE_BUSINESS_FAILURE,
  payload: {
    error,
  },
});

interface IUserBusinessAction {
  type: UserActions.USER_BUSINESS;
}

export const userBusinessAction = (): IUserBusinessAction => ({
  type: UserActions.USER_BUSINESS,
});

export interface IUserBusinessSuccessAction {
  type: UserActions.USER_BUSINESS_SUCCESS;
  payload: IUserBusinessDto;
}

export const userBusinessSuccessAction = (
  payload: IUserBusinessDto,
): IUserBusinessSuccessAction => ({
  type: UserActions.USER_BUSINESS_SUCCESS,
  payload,
});

interface IUserBusinessFailureAction {
  type: UserActions.USER_BUSINESS_FAILURE;
  payload: {
    error: string;
  };
}

export const userBusinessFailureAction = (
  error: string,
): IUserBusinessFailureAction => ({
  type: UserActions.USER_BUSINESS_FAILURE,
  payload: {
    error,
  },
});

export type IUserActions =
  | IUserBusinessAction
  | IUserBusinessSuccessAction
  | IUserBusinessFailureAction
  | ICreateBusinessAction
  | ICreateBusinessSuccessAction
  | ICreateBusinessFailureAction
  | IGetUserInfoAction
  | IGetUserInfoSuccessAction
  | IGetUserInfoFailureAction
  | IUpdateBusinessAction
  | IUpdateUserInfoAction
  | IUpdateUserInfoSuccessAction
  | IGetUserListAction
  | IGetUserListSuccessAction
  | IGetUserListFailureAction
  | ISetListFiltersAction;
